import { runtime } from "@Config/runtime";
const gatewayUrl = runtime.gatewayUrl;
export { gatewayUrl };
